import { ReactElement, FC, useEffect, useState } from 'react'
import StarRatings from 'react-star-ratings'
import { getDatabase, ref, onValue, runTransaction } from 'firebase/database'
import styled, { useTheme } from 'styled-components'
import { AiFillStar } from 'react-icons/ai'

interface UserVoteProps {
  tippId: string
  handleUpdateRatingCount: (rating: number) => void
}

const UserVote: FC<UserVoteProps> = ({
  tippId,
  handleUpdateRatingCount,
}): ReactElement => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [userRating, setUserRating] = useState<number | undefined>(-1)
  const [userChoice, setUserChoice] = useState<number | undefined>(-1)
  const [userIsRating, setUserIsRating] = useState(false)
  const [audienceRating, setAudienceRating] = useState(-1)
  const theme = useTheme() as any

  const handleAddVote = () => {
    const db = getDatabase()

    setIsSubmitting(true)
    localStorage.setItem(tippId, userChoice ? userChoice.toString() : '0')
    console.log('Add vote for', tippId, 'with value', userChoice)

    const postRef = ref(db, 'votes/' + tippId + '/' + userChoice + /votes/)

    runTransaction(postRef, (post) => {
      if (post) {
        post += 1
      } else {
        post = 1
      }
      return post
    })

    // const newVote = firebaseDatabase.ref(
    //   'votes/' + tippId + '/' + userChoice + /votes/
    // )
    // newVote.transaction(
    //   (currentVotes:any) => {
    //     return currentVotes + 1
    //   },
    //   (error:any, committed:any, snapshot:any) => {
    //     if (error) {
    //       // console.log('Transaction failed abnormally!', error)
    //     } else if (!committed) {
    //       // console.log('Transaction aborted')
    //     } else {
    //       /* transaction complete */
    //       setUserRating(userChoice)
    //     }
    //   }
    // )
  }

  const handleRate = (newRating: number) => {
    setUserIsRating(true)
    setUserChoice(newRating)
  }

  const handleCancelRate = () => {
    setUserIsRating(false)
  }

  const popContent = !isSubmitting ? (
    <ConfirmContainer>
      <div>
        Votre note
      </div>
      <div>{new Array((userChoice && userChoice > 0) ? userChoice : 0).fill(0).map((s, i) => <AiFillStar key={`start-${i}`} />)}</div>
      <div>
        <div className='sure'>Confirmer?</div>
        <ButtonsContainer>
        <Button onClick={handleAddVote}>
          <div>Oui</div>
        </Button>
        <Button onClick={handleCancelRate}>
          <div>Non</div>
        </Button>
        </ButtonsContainer>
      </div>
    </ConfirmContainer>
  ) : (
    <div className='confirm-wrapper'>
      <div className='ui segment'>
        <div className='ui active inverted dimmer' />
        <p />
      </div>
    </div>
  )

  useEffect(() => {
    const db = getDatabase()
    const votes = ref(db, 'votes/' + tippId)

    onValue(votes, (snapshot) => {
      const oneStarVotes = snapshot.child('1/votes').val()
      const twoStarVotes = snapshot.child('2/votes').val()
      const threeStarVotes = snapshot.child('3/votes').val()
      const fourStarVotes = snapshot.child('4/votes').val()
      const fiveStarVotes = snapshot.child('5/votes').val()

      const totalStars =
        oneStarVotes +
        twoStarVotes * 2 +
        threeStarVotes * 3 +
        fourStarVotes * 4 +
        fiveStarVotes * 5
      const totalVotes =
        oneStarVotes +
        twoStarVotes +
        threeStarVotes +
        fourStarVotes +
        fiveStarVotes
      const averageVote = totalStars / totalVotes

      setAudienceRating(averageVote)
      setIsSubmitting(false)
      setUserIsRating(false)

      handleUpdateRatingCount(totalVotes)
      // console.log('Set new value', tippId)
      const storedRating = localStorage.getItem(tippId)

      if (storedRating) {
        setUserRating(parseInt(storedRating))
      }
    })
  }, [handleUpdateRatingCount, tippId])

  return (
    <Container onClick={(e) => {e.preventDefault()}}>
      <StarRatings
        rating={
          userIsRating
            ? userChoice
            : userRating === undefined
            ? audienceRating
              ? parseFloat((Math.round(audienceRating * 2) / 2).toFixed(1)) // round to nearest .5
              : 0
            : audienceRating
            ? parseFloat((Math.round(audienceRating * 2) / 2).toFixed(1)) // round to nearest .5
            : 0
        }
        starRatedColor={`var(--tenant-${theme.tenant.key.slice(0, 3)})`}
        starEmptyColor='var(--site-background)'
        svgIconPath='M24 1.175l7.553 14.84L48 18.611 36.22 30.38l2.613 16.444L24 39.26 9.167 46.825 11.78 30.38 0 18.613l16.447-2.598z'
        starDimension='20px'
        starSpacing='3px'
        starHoverColor={`var(--tenant-${theme.tenant.key.slice(0, 3)})`}
        changeRating={userRating === -1 ? handleRate : undefined}
        numberOfStars={5}
        name='rating'
      />
      {userIsRating && popContent}
    </Container>
  )
}

const Container = styled.div`
  position: relative;

  // &:hover {
  //   &:after {
  //     content: 'Voter';
  //     position: absolute;
  //     bottom: -20px;
  //     left: 0;
  //   }
  // }
`

const ConfirmContainer = styled.div`
  position: absolute;
  bottom: 40px;
  left: 0;
  font-family: var(--font-plex);
  background: ${({theme}) => theme.coloredBackground};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  padding: 18px;
`

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
`

const Button = styled.div`
display: inline-block;
color: ${({theme}) => theme.primaryButtonText};
background: ${({theme}) => theme.primaryButtonBackground};
padding: 3px 20px;
`

export default UserVote
